import script from "./HeroPdv.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroPdv.vue?vue&type=script&setup=true&lang=js"

import "./HeroPdv.vue?vue&type=style&index=0&id=6845e482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6845e482"]])

export default __exports__